import { Col, Menu, Row } from 'antd'
import { memo, useMemo } from 'react'
import { Outlet, useMatch, useNavigate } from 'react-router-dom'

export default memo(function OrganizationMemberIndex() {
  const navigate = useNavigate()
  const match = useMatch('/:organizationName/:key')
  const activeKey = useMemo(() => match?.params.key || '', [match])

  return (
    <Row gutter={16}>
      <Col flex={' 0 0 250px'}>
        <Menu
          mode='inline'
          selectedKeys={[activeKey]}
          onSelect={({ key }) => {
            navigate(key)
          }}
        >
          <Menu.Item key='members'>Members</Menu.Item>
          <Menu.Item key='manage-members'>Managed Members</Menu.Item>
          <Menu.Item key='pending-invitations'>Pending Invitations</Menu.Item>
          <Menu.Item key='failed-invitations'>Failed Invitations</Menu.Item>
        </Menu>
      </Col>
      <Col flex={'auto'}>
        <Outlet />
      </Col>
    </Row>
  )
})
